import type { MouseEvent as ReactMouseEvent } from "react";

type LinkClickEvent = MouseEvent | ReactMouseEvent<HTMLElement>;

export const IGNORE_SAME_ORIGIN_LINK_CLICK_ATTRIBUTE =
  "data-focus-ignore-same-origin-link-click";

export const getSameOriginLinkUrlFromEvent = (
  event: LinkClickEvent,
): URL | null => {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.altKey ||
    event.ctrlKey ||
    event.shiftKey ||
    typeof window === "undefined"
  ) {
    return null;
  }

  const target = event.target;

  if (!(target instanceof HTMLElement)) {
    return null;
  }

  if (target.closest(`[${IGNORE_SAME_ORIGIN_LINK_CLICK_ATTRIBUTE}]`)) {
    return null;
  }

  const anchor = target.closest<HTMLAnchorElement>("a[href]");

  if (!anchor || anchor.hasAttribute("download")) {
    return null;
  }

  const targetAttr = anchor.getAttribute("target");

  if (targetAttr && targetAttr !== "_self") {
    return null;
  }

  const url = new URL(anchor.href, window.location.href);

  return url.origin === window.location.origin ? url : null;
};
